import { createContext, useContext, useEffect, useState } from 'react';

const defaultState = {
  propertycondition: '',
  reasonforselling: '',
  timeframe: '',
  propertyvalue: 550000,
  city: '',
  state: '',
  zip: '',
  realtorlisting: '',
  step: 1,
  propertytype: '',
  creditscore: '',
  source_url: window.location.origin + window.location.pathname,
};

const FormDataContext = createContext();

export const useFormDataContext = () => useContext(FormDataContext);

export const FormDataProvider = ({ children }) => {
  const [formData, setFormData] = useState(defaultState);

  const updateFormData = (data) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...data,
    }));
  };

  const clearStorage = () => setFormData(defaultState);

  const updateStep = (step) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      step,
    }));
  };

  return (
    <FormDataContext.Provider
      value={{ formData, updateFormData, updateStep, clearStorage }}
    >
      {children}
    </FormDataContext.Provider>
  );
};
